import { Box, Typography } from "@mui/material";

export default function OnboardingLocal() {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 4, py: 2, px: 5 }}
    >
      {/* Step 1 */}
      <Box textAlign="left">
        <Box
          component="span"
          className="fas fa-magnifying-glass"
          sx={{ color: "primary.main", fontSize: 16, mr: 1 }}
        />
        <Typography
          variant="h6"
          component="div"
          fontWeight="bold"
          display="inline"
        >
          Step 1: Search
        </Typography>
        <Typography mt={1}>
          Use the searchbar above to find local brands. Try searches like:
          <ul style={{ paddingLeft: 20, marginTop: 4 }}>
            <li>Hotels in Miami</li>
            <li>Coffee shops in Vancouver</li>
            <li>Medspas in Dallas</li>
            <li>Spas in Los Angeles</li>
            <li>Dental offices in Chicago</li>
            <li>Pilates in New York</li>
          </ul>
          You don't need to include "in [city]" if you want to search the
          current map area. Also try zooming into the map and using the "Search
          this area" button for more results.
        </Typography>
      </Box>

      {/* Step 2 */}
      <Box textAlign="left">
        <Box
          component="span"
          className="fas fa-plus-circle"
          sx={{ color: "primary.main", fontSize: 16, mr: 1 }}
        />
        <Typography
          variant="h6"
          component="div"
          fontWeight="bold"
          display="inline"
        >
          Step 2: Add Brands
        </Typography>
        <Typography mt={1}>
          Click the <strong>Add +</strong> button on any brand to add it to your
          outreach list.
        </Typography>
      </Box>

      {/* Step 3 */}
      <Box textAlign="left">
        <Box
          component="span"
          className="fas fa-rocket"
          sx={{ color: "primary.main", fontSize: 16, mr: 1 }}
        />
        <Typography
          variant="h6"
          component="div"
          fontWeight="bold"
          display="inline"
        >
          Step 3: Pitch Automatically
        </Typography>
        <Typography mt={1}>
          Click the <strong>"Pitch to brands"</strong> button at the bottom,
          choose a template, and pick dates to schedule the emails.
        </Typography>
      </Box>
    </Box>
  );
}
